import "./Loading.css"

interface LoadingProps {
  className?: string
  widthFit?: boolean
  style?: React.CSSProperties
}

export default function Loading({ className, widthFit, style }: LoadingProps) {
  return (
    <div
      style={style}
      className={`loading d-flex justify-content-center ${!widthFit ? "w-100" : ""}`}
    >
      <div className={"lds-ring " + (className || "")}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}
